import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './PsLinkLabel.css';

export const PsLinkLabel = (
    {
        to,
        label,
        labelStyle,
    },
) => {
    const classNames = `ps-link-label ${to === '#' ? 'ps-no-link' : ''}`

    return (
        <Link to={to} className={classNames}>
            <span style={labelStyle}>{label}</span>
        </Link>
    );
};

PsLinkLabel.propTypes = {
    to: PropTypes.string,
    label: PropTypes.string,
    labelStyle: PropTypes.object,
};

PsLinkLabel.defaultProps = {
    to: '#',
    label: '',
    labelStyle: undefined,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/ps-link-label/PsLinkLabel.jsx